var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSaveIcon = function SvgSaveIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 75,
    viewBox: "0 0 65 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7003 13.9524C18.6361 13.9524 15.3413 17.2471 15.3413 21.3114V67.2617C15.3413 71.326 18.6361 74.6207 22.7003 74.6207H57.0218C61.086 74.6207 64.3808 71.326 64.3808 67.2617V22.683L53.8471 13.9524H22.7003Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0303 12.8181V17.1334C52.0303 19.5719 54.0071 21.5488 56.4457 21.5488H62.3715H62.564",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0358 10.2878C14.9715 10.2878 11.6768 13.5826 11.6768 17.6469V63.5972C11.6768 67.6614 14.9715 70.9562 19.0358 70.9562H53.3572C57.4215 70.9562 60.7162 67.6614 60.7162 63.5972V19.0185L50.1825 10.2878H19.0358Z",
    stroke: "#1A1E22",
    strokeWidth: 1.73608
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1851 10.2878V14.6031C50.1851 17.0416 52.1619 19.0185 54.6005 19.0185H60.7188",
    stroke: "#1A1E22",
    strokeWidth: 1.73608
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4081 21.8994H49.6611C50.4231 21.8994 51.0409 22.5172 51.0409 23.2792V30.178C51.0409 30.94 50.4231 31.5577 49.6611 31.5577H22.7391C21.9771 31.5577 21.3594 30.94 21.3594 30.178V23.2792C21.3594 22.5172 21.9771 21.8994 22.7391 21.8994H30.3995H30.9333",
    stroke: "#0157FF",
    strokeWidth: 1.73608
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.3594,
    y: 36.9668,
    width: 29.6815,
    height: 9.65832,
    rx: 1.4718,
    stroke: "#1A1E22",
    strokeWidth: 1.73608
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3594,
    y: 52.0337,
    width: 29.6815,
    height: 9.65832,
    rx: 1.4718,
    stroke: "#1A1E22",
    strokeWidth: 1.73608
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5854 25.0372L29.1309 27.8204L36.1975 20.8669",
    stroke: "#0157FF",
    strokeWidth: 1.73608
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44901 11.7505L1.49753 12.0085",
    stroke: "#FFBE00",
    strokeWidth: 1.73608
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1632 5.92816L11.1632 1.0695",
    stroke: "#FFBE00",
    strokeWidth: 1.73608
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04206 8.3895L3.15039 3.42236",
    stroke: "#FFBE00",
    strokeWidth: 1.73608
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSaveIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "SAVE_ICON.a30ee1e3b29cc4025928a89aef570d8e.svg";